import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgListViewinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21 4H8M4 4H3m18 8H8m-4 0H3m18 8H8m-4 0H3",
		fill: "none",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2
	})
});
export default SvgListViewinline;
